import { render } from "./ImgLinks.vue?vue&type=template&id=36ec0128&scoped=true"
import script from "./ImgLinks.vue?vue&type=script&lang=js"
export * from "./ImgLinks.vue?vue&type=script&lang=js"

import "./ImgLinks.vue?vue&type=style&index=0&id=36ec0128&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36ec0128"

export default script